import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgxAimStationSelectDay } from './ngx-aim-station-select-day.class';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { NgClass } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'ngx-aim-station-select-day',
  standalone: true,
  imports: [CalendarModule, FormsModule, ButtonModule, NgClass, ProgressSpinnerModule],
  templateUrl: './ngx-aim-station-select-day.component.html',
  styleUrl: './ngx-aim-station-select-day.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxAimStationSelectDayComponent extends NgxAimStationSelectDay implements OnInit {
  ngOnInit() {
    this.init();
  }
}
